<template>
  <div class="page page-home">
    <MeterRead />
    <Dots />
    <div class="consumptions">
      <ConsumptionFrom type="community" />
      <ConsumptionFrom type="supplier" />
    </div>
    <template v-if="!$store.getters.isCubeReachable">
      <ContentPopup>
        <template v-slot:content>
          <p v-html="str('global.cubeNotReachableMessage')"></p>
        </template>
      </ContentPopup>
      <div class="page-home__overlay"></div>
    </template>
  </div>
</template>

<script>
  import Dots from '@/components/consumption/Dots'
  import MeterRead from '@/components/consumption/MeterRead'
  import ConsumptionFrom from '@/components/consumption/ConsumptionFrom'
  import ContentPopup from '@/components/ContentPopup'

  export default {
    name: 'page-home',
    components: {
      MeterRead,
      ConsumptionFrom,
      Dots,
      ContentPopup,
    },
  }
</script>

<style lang="scss">
  .page-home {
    position: absolute;
    top: 50%;
    left: 0;
    right: 0;
    transform: translateY(-50%);

    &__overlay {
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      background: rgba(255, 255, 255, 0.7);
      transition: $transition-base;
    }
  }

  .consumptions {
    // The wrapper for the 2 consumption components.
    display: flex;
    justify-content: center;

    .consumption-from {
      flex-basis: 45%;
      max-width: 180px;
      transition: $transition-base;

      @media (min-height: 1000px) and (min-width: $bp-md) {
        max-width: 220px;
      }

      &:first-child {
        margin-right: 2%;

        @media (min-height: 700px) and (min-width: $bp-ssm) {
          margin-right: 7%;
        }
      }

      &:last-child {
        margin-left: 2%;

        @media (min-height: 700px) and (min-width: $bp-ssm) {
          margin-left: 7%;
        }
      }
    }
  }
</style>
